import { useState } from "react";
import { Link } from "react-router";
import { cn } from "../../core/helpers/cn";
import { router } from "../../core/helpers/router";
import FirebaseService from "../../core/services/firebase.service";
import BottomSheetPopup from "../BottomSheetPopup/BottomSheetPopup";
import FirebaseKey from "../FirebaseKey/FirebaseKey";

interface LoginPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginSubmit?: (msisdn: string) => Promise<void>;
}

const LoginPopup = ({ isOpen, onClose, onLoginSubmit }: LoginPopupProps) => {
  const [phoneSuffix, setPhoneSuffix] = useState("");
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(false);
    const fullPhone = "90" + phoneSuffix.replace(/\s/g, "");
    if (!onLoginSubmit) {
      onClose();
      return;
    }
    setIsSubmitting(true);
    try {
      await onLoginSubmit(fullPhone);
      onClose();
    } catch {
      setError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <BottomSheetPopup isOpen={isOpen} onClose={onClose}>
      <h2 className="text-[32px] font-semibold text-black mb-6"><FirebaseKey firebaseKey={FirebaseService.login_title} /></h2>
      <form onSubmit={handleSubmit} className="flex flex-col">
        <div className="w-full flex items-center p-5 rounded-full bg-[rgba(128,126,125,0.12)] gap-1">
          <span className={cn(`shrink-0`, 'text-black', phoneSuffix.length === 0 && 'text-[rgba(67,66,66,0.30)]', error && 'text-[#FF383C]')}>+90</span>
          <input
            type="tel"
            placeholder="5XX XXX XX XX"
            maxLength={10}
            value={phoneSuffix}
            onChange={(e) => setPhoneSuffix(e.target.value.replace(/[^0-9]/g, ''))}
            className="flex-1 min-w-0 bg-transparent text-black placeholder:text-[rgba(67,66,66,0.30)] border-0 focus:outline-none"
            autoComplete="tel-national"
          />
        </div>
        <span className="mb-6 text-sm text-[#FF383C]">
          {error && <FirebaseKey firebaseKey={FirebaseService.login_warning} />}
        </span>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full p-4 rounded-full bg-[#0088FF] text-white font-medium transition-colors disabled:opacity-70"
        >
          <FirebaseKey firebaseKey={FirebaseService.login_button} />
        </button>
      </form>
      <Link
        to={router.AGREEMENT}
        onClick={onClose}
        className="text-xs font-medium text-[rgba(67,66,66,0.60)] mt-1 text-center block hover:underline"
      >
        <FirebaseKey firebaseKey={FirebaseService.login_terms_text} />
      </Link>
    </BottomSheetPopup>
  );
};

export default LoginPopup;
